var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('notifications-loader'),_vm._v(" "),_c('header',[_c('header-top',{attrs:{"hasNav":_vm.hasNav}}),_vm._v(" "),(_vm.showOngoingMeeting)?_c('OngoingMeetings',{attrs:{"limit":1}}):_vm._e(),_vm._v(" "),(_vm.hasNav)?_c('header-bottom'):_vm._e()],1),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44093800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logged-in-layout/logged-in-layout.vue
// module id = D6ct
// module chunks = 1